export default "__VITE_ASSET__100ab578__"